import axiosInstance from "@/config/axios";

interface GetNonFinanceParams {
	companyId: string;
	skip?: number;
	limit?: number;
	yearly?: number;
	search?: string;
	createdAt?: string;
}
export const getNonFinance = async (params: {
	[key: string]: string | number | undefined;
}) => {
	const response = await axiosInstance.get("/non-financial/company", {
		params,
	});
	return response.data;
};

interface NonFinanceResponse {
	status: boolean;
	message: string;
	data: {
		id: string;
		name: string;
		coreSectorId: string;
		startDate: string;
		expiryDate: string;
		yearly: number;
		createdBy: string;
		updatedBy: string;
		createdAt: string;
		updatedAt: string;
		coreSector: {
			id: string;
			coreSector: string;
		};
		nonFinancialTitles: Array<{
			id: string;
			index: number;
			formId: string;
			title: string;
			nonFinancialDetails: Array<{
				id: string;
				index: number;
				titleId: string;
				formId: string;
				question: string;
			}>;
		}>;
	};
}

export const getQuestion = async (id: string): Promise<NonFinanceResponse> => {
	try {
		const response = await axiosInstance.get(`/non-financial/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error in getQuestion:", error);
		throw error;
	}
};

interface NonFinAnswerDetail {
	question: string;
	questionId: string;
	answer: number;
	description: string | null;
}

interface NonFinAnswerTitle {
	titleAnswer: string;
	nonFinAnswerDetails: NonFinAnswerDetail[];
}

interface AnswerPayload {
	fromId: string;
	nonFinAnswerTitles: NonFinAnswerTitle[];
}

export const postAnswer = async (data: AnswerPayload) => {
	try {
		const response = await axiosInstance.post(
			"/non-financial/answer-in-system",
			data,
		);
		if (!response.data) {
			throw new Error("No response received from server");
		}
		return response.data;
	} catch (error) {
		console.error("Error posting answer:", error);
		throw error;
	}
};
interface FormLinkPayload {
	formId: string;
}

export const postFormLink = async (payload: FormLinkPayload) => {
	try {
		const response = await axiosInstance.post(
			"/non-financial/form-link",
			payload,
		);
		return response.data;
	} catch (error) {
		console.error("Error posting form link:", error);
		throw error;
	}
};
